import React, { createContext, useState, useContext } from 'react';

// Creamos el contexto
export const CheckoutContext = createContext();

// Creamos un proveedor del contexto
export const CheckoutProvider = ({ children }) => {

   //Tipo de envios

   const [tipoEntrega, setTipoEntrega] = useState(null); // Retiro = 1 y Envio = 2 (null = sin selección) 
   const [codDic, setCodDic] = useState();
   const [precioFleteDireccion, setPrecioFleteDireccion] = useState(0);
  // Teléfono principal proveniente de la dirección seleccionada (para facturación)
  const [telefonoDireccionPrincipal, setTelefonoDireccionPrincipal] = useState('');
  // Teléfono editable para el pedido (prioridad en facturación)
  const [telefonoFacturacion, setTelefonoFacturacion] = useState('');


//Datos de facturacion
const [deseaFactura, setDeseaFactura] = useState(false);
const [tipoResponsable, setTipoResponsable] = useState(0);
const [razonSocial, setRazonSocial] = useState('');
const [cuit, setCuit] = useState('');

//Horario de retiro
const [fechaRetiroSeleccionada, setFechaRetiroSeleccionada] = useState('');
const [codigoHorarioSeleccionado, setCodigoHorarioSeleccionado] = useState('');
// Texto legible del rango horario seleccionado (ej: "09:00 - 12:00")
const [horarioTexto, setHorarioTexto] = useState('');

// Código de compra para unificar pedidos
const [codCompraUnifica, setCodCompraUnifica] = useState(0);

// Nuevos campos para persona autorizada
const [nombreAutorizado, setNombreAutorizado] = useState('');
const [dniAutorizado, setDniAutorizado] = useState('');
// Campo para observaciones
const [observaciones, setObservaciones] = useState('');
// Campo para aceptación de reemplazo
const [aceptaReemplazo, setAceptaReemplazo] = useState(true);

  
  // Estado para el tipo de pago
  const [tipoPago, setTipoPago] = useState('0'); // Código para tarjeta de débito por defecto
  const [tarjeta, setTarjeta] = useState('');
  const [plan, setPlan] = useState('');
  const [cuotas, setCuotas] = useState('');
  const [coeficiente, setCoeficiente] = useState('');
  const [totalDeCuota, setTotalDeCuota] = useState('');
  const [totalFinal, setTotalFinal] = useState('');
  const [nroEmision, setNroEmision] = useState('');
  const [nroPlan, setNroPlan] = useState('');
  const [marcaTarjeta, setMarcaTarjeta] = useState('');


  //Cuenta Empleado
    const [saldoCuenta, setSaldoCuenta] = useState(null);
  
  //Billetera Santa Fe
  const [datosBilletera, setDatosBilletera] = useState(null);
  
  //MODO App
  const [datosModo, setDatosModo] = useState(null);

  // Envíos pendientes (para unificar pedidos)
  const [enviosPendientes, setEnviosPendientes] = useState([]);
  

  // Valores y funciones que estarán disponibles en el contexto
  const value = {
    //tipo de envios
    tipoEntrega,
    setTipoEntrega,
    codDic,
    setCodDic,
    precioFleteDireccion,
    setPrecioFleteDireccion,
    telefonoDireccionPrincipal,
    setTelefonoDireccionPrincipal,
    telefonoFacturacion,
    setTelefonoFacturacion,

    //Datos de facturacion
    deseaFactura,
    setDeseaFactura,
    tipoResponsable,
    setTipoResponsable,
    razonSocial,
    setRazonSocial,
    cuit,
    setCuit,
    nombreAutorizado,
    setNombreAutorizado,
    dniAutorizado,
    setDniAutorizado,
    observaciones,
    setObservaciones,
    aceptaReemplazo,
    setAceptaReemplazo,

    //Horario de retiro
    fechaRetiroSeleccionada,
    setFechaRetiroSeleccionada,
    codigoHorarioSeleccionado,
    setCodigoHorarioSeleccionado,
    horarioTexto,
    setHorarioTexto,
    
    // Unificar pedidos
    codCompraUnifica,
    setCodCompraUnifica,
    
    //tipo de pagos
    tipoPago,
    setTipoPago,
    tarjeta,
    setTarjeta,
    plan,
    setPlan,
    cuotas,
    setCuotas,
    coeficiente,
    setCoeficiente,
    totalDeCuota,
    setTotalDeCuota,
    totalFinal,
    setTotalFinal,
    nroEmision,
    setNroEmision,
    nroPlan,
    setNroPlan,
    marcaTarjeta,
    setMarcaTarjeta,

    //Cuenta Empleado
    saldoCuenta,
    setSaldoCuenta,

    //Billetera Santa Fe
    datosBilletera,
    setDatosBilletera,

    //MODO App
    datosModo,
    setDatosModo,

    // Envíos pendientes
    enviosPendientes,
    setEnviosPendientes,
  };

  return (
    <CheckoutContext.Provider value={value}>
      {children}
    </CheckoutContext.Provider>
  );
};

// Hook personalizado para usar el contexto fácilmente
export const useCheckoutContext = () => {
  const context = useContext(CheckoutContext);
  
  if (context === undefined) {
    throw new Error('useCheckout debe ser usado dentro de un CheckoutProvider');
  }
  
  return context;
};
